/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ invNo: NonNullable<unknown> }} Einvoice_Status_Issued_ShortInputs */

const vi_einvoice_status_issued_short = /** @type {(inputs: Einvoice_Status_Issued_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã xuất HĐ #${i?.invNo}`)
};

/**

* @param {Einvoice_Status_Issued_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_status_issued_short = /** @type {((inputs: Einvoice_Status_Issued_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Status_Issued_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_status_issued_short(inputs)
});